import React, { useEffect, useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import Switch from "components/Shared/Switch"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import {
  addCouponGroup,
  deleteCouponGroup,
  getAllCouponsGroup,
  getCouponGroupDetails,
  updateBulkCouponGroup,
  updateCouponGroup,
  updateCouponGroupStatus,
} from "store/actions/promotionsAction"
import { ShimmerSimpleGallery } from "react-shimmer-effects"
import { showAlert } from "store/reducers/alertReducer"
import DeleteModal from "components/Common/DeleteModal"
import { ErrorMessage, Field, Form, Formik } from "formik"
import { addCouponGroupSchema } from "components/Common/validation"
import Filters from "components/Common/Filters"
import { filters } from "components/Common/constants"
import Paginations from "components/Common/Paginations"
import isPermissionEnabled from "common/isPermissionEnabled"
import { DatePicker } from "rsuite"
import { isBefore, startOfDay } from "date-fns"
import { useTranslation } from "react-i18next"
import SensitiveActionOtpModal from "components/Shared/SensitiveActionOtpModal"
import useSensitiveAction from "hooks/useSensitiveAction"
import { SENSITIVE_MODULES } from "helpers/sensitiveActionModules"
import TextError from "components/Shared/TextError"

const initialValues = {
  name: "",
  nameAr: "",
  status: true,
}

const CouponsGroups = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Coupons Group List | Sign Burger")
  const dispatch = useDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const pageNumber = parseInt(searchParams.get("page")) || 1
  const navigate = useNavigate()

  const {
    loading,
    itemsPerPage,
    totalCount,
    totalPages,
    currentPage,
    isUpdating,
    isLoading,
    couponsGroups,
    couponGroupDetails,
    couponGroupLoading,
  } = useSelector(state => state.Promotions)

  const [isApiCalled, setIsApiCalled] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [modal, setModal] = useState(false)
  const [formValues, setFormValues] = useState(initialValues)
  const [actionType, setActionType] = useState(null)

  const submitCouponGroupWithOtp = (data, actionOtp) => {
    const { kind } = data

    if (kind === "STATUS") {
      return dispatch(
        updateCouponGroupStatus({
          id: data.id,
          status: data.status === 1 ? "0" : "1",
          actionOtp,
        })
      ).then(action => {
        const { statusCode, status, msg } = action?.payload || {}
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setSelectedId(null)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
        return action
      })
    }

    if (kind === "BULK") {
      return dispatch(
        updateBulkCouponGroup({
          couponGroup: data.couponGroup,
          expiresAt: data.expiresAt,
          actionOtp,
        })
      ).then(action => {
        const { statusCode, status, msg } = action?.payload || {}
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowDatePicker(false)
          setSelectedId(null)
          setExpiresAt(null)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
        return action
      })
    }

    const { values, resetForm, actionType: currentAction } = data
    const { name, nameAr, status } = values
    const payload = {
      actionOtp,
      name,
      nameAr,
      status: currentAction === "ADD" ? 1 : status ? 1 : 0,
    }

    if (currentAction === "ADD") {
      return dispatch(addCouponGroup(payload)).then(action => {
        const { statusCode, status, msg } = action?.payload || {}
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          resetForm()
          toggle()
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
        return action
      })
    }

    return dispatch(
      updateCouponGroup({ ...payload, id: selectedId })
    ).then(action => {
      const { statusCode, status, msg } = action?.payload || {}
      if (statusCode === 200 && status) {
        dispatch(showAlert({ text: msg, type: "success" }))
        resetForm()
        toggle()
      } else {
        dispatch(showAlert({ text: msg, type: "error" }))
      }
      return action
    })
  }

  const { startSensitiveAction, modalProps, isActionBusy } = useSensitiveAction({
    module: SENSITIVE_MODULES.COUPON_GROUP,
    onSubmitWithOtp: submitCouponGroupWithOtp,
  })

  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  const [showDatePicker, setShowDatePicker] = useState(false)
  const [expiresAt, setExpiresAt] = useState(null)
  const [selectedFilters, setSelectedFilters] = useState({
    status: parseInt(searchParams.get("status") || "2"),
    sortOrder: parseInt(searchParams.get("sortOrder") || "2"),
  })
  const toggle = () => setModal(!modal)

  const { userRole, accountType } = useSelector(state => state.Login)

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    create: null,
    edit: null,
    delete: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      14,
      "promotion_1",
      accountType
    )
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      14,
      "promotion_2",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      14,
      "promotion_3",
      accountType
    )
    const isPermissionDelete = isPermissionEnabled(
      userRole,
      14,
      "promotion_4",
      accountType
    )
    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
      edit: isPermissionEdit,
      delete: isPermissionDelete,
    })
  }, [userRole])

  useEffect(() => {
    fetchAllCouponsGroup()
  }, [])

  const fetchAllCouponsGroup = () => {
    const { status, sortOrder } = selectedFilters

    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      status,
      orderBy: sortOrder,
      keyword: searchTerm,
    }
    dispatch(getAllCouponsGroup(payload))
    setIsApiCalled(true)
  }

  const handleEnablePromotion = (id, status) => {
    setSelectedId(id)
    startSensitiveAction({ kind: "STATUS", id, status })
  }

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // 2 FOR DELETE
    }
    dispatch(deleteCouponGroup(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowDeleteModal(false)
          setItemIdToDelete(null)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleAddCouponGroup = (values, { resetForm }) => {
    startSensitiveAction({ values, resetForm, actionType })
  }

  const handleEditCouponGroup = id => {
    setSelectedId(id)
    const payload = {
      id,
    }
    dispatch(getCouponGroupDetails(payload))
    setActionType("EDIT")
    toggle()
    setFormValues(prevValues => ({
      ...prevValues,
      name: "",
      nameAr: "",
      status: true,
    }))
  }

  useEffect(() => {
    if (couponGroupDetails && actionType === "EDIT") {
      const { name, nameAr, status } = couponGroupDetails
      const updatedStatus = status === 1 ? true : false
      setFormValues(prevValues => ({
        ...prevValues,
        name,
        nameAr,
        status: updatedStatus,
      }))
    } else if (actionType === "ADD") {
      setFormValues(prevValues => ({
        ...prevValues,
        name: "",
        nameAr: "",
        status: true,
      }))
    }
  }, [couponGroupDetails, actionType])

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const fetchCouponsGroups = page => {
    const { status, sortOrder } = selectedFilters

    const searchParams = new URLSearchParams()
    searchParams.set("search", searchTerm)
    searchParams.set("status", status.toString())
    searchParams.set("sortOrder", sortOrder.toString())
    searchParams.set("page", page.toString())

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: Number(status),
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
    }

    dispatch(getAllCouponsGroup(payload))
      .then(() => {
        // Navigate to the updated URL after fetching data
        navigate(`/coupons-group?${searchParams.toString()}`)
      })
      .catch(error => {
        console.error(error)
      })
  }

  const handleSearch = () => {
    fetchCouponsGroups(1) // Always start from page 1 for search
  }

  const onPageChange = page => {
    fetchCouponsGroups(page) // Use the selected page for pagination
  }

  // useEffect(() => {
  //   if (isApiCalled) {
  //     const delayDebounceFn = setTimeout(() => {
  //       handleSearch()
  //     }, 500)

  //     return () => clearTimeout(delayDebounceFn)
  //   }
  // }, [searchTerm])

  // useEffect(() => {
  //   if (isApiCalled) {
  //     handleSearch()
  //   }
  // }, [selectedFilters])

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  const handleReset = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      status: 2,
      orderBy: 2,
      keyword: "",
    }
    dispatch(getAllCouponsGroup(payload))

    setSelectedFilters({
      status: 2,
      sortOrder: 2,
    })
    setSearchTerm("")
  }

  const handleUpdateBulkCouponGroup = () => {
    startSensitiveAction({ kind: "BULK", couponGroup: selectedId, expiresAt })
  }

  return (
    <div className="page-content">
      <SensitiveActionOtpModal {...modalProps} />
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <DataExportDropdown
                cardTitle={t("Coupons Group List")}
                isAddBtn={loading ? false : usersPermissions.create}
                addBtnText={t("Add Coupon Group")}
                onAddBtnClick={() => {
                  toggle()
                  setActionType("ADD")
                }}
              />
              <CardBody>
                <Filters
                  filters={filters}
                  searchTerm={searchTerm}
                  handleSearchChange={handleSearchChange}
                  handleFilterChange={handleFilterChange}
                  handleSearch={handleSearch}
                  onReset={handleReset}
                  selectedFilters={selectedFilters}
                  searchBy={t("Name")}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          {loading ? (
            <Row className="item_shimmer">
              {[1, 2, 3].map(item => (
                <React.Fragment key={item}>
                  <Col
                    lg={12}
                    className={`pe-0 first ${
                      item !== 1 && "promotion_shimmer"
                    }`}
                  >
                    <ShimmerSimpleGallery
                      card
                      imageHeight={70}
                      col={3}
                      row={2}
                    />
                  </Col>
                </React.Fragment>
              ))}
            </Row>
          ) : couponsGroups.length === 0 ? (
            <p className="text-center my-2">{t("No coupons group found")}</p>
          ) : (
            couponsGroups?.map(({ _id, name, nameAr, status }) => (
              <Col lg={4} key={_id}>
                <Card className="full_height_card">
                  <CardBody>
                    <div
                      className="d-flex justify-content-between align-items-start cursor-pointer"
                      onClick={() => navigate(`/coupons-group/${_id}/coupons`)}
                    >
                      <CardTitle className="in_2_line fs-6">
                        {language === "sa" ? nameAr : name}
                      </CardTitle>
                      <div className="d-flex ">
                        {usersPermissions.edit && (
                          <Switch
                            onClickHandler={e => {
                              e.stopPropagation()
                              handleEnablePromotion(_id, status)
                            }}
                            isChecked={status === 1}
                            disabled={
                              isActionBusy ||
                              (_id === selectedId && isUpdating)
                            }
                          />
                        )}
                        <UncontrolledDropdown>
                          <DropdownToggle
                            tag="a"
                            className="card-drop"
                            onClick={e => e.stopPropagation()}
                          >
                            <i className="mdi mdi-dots-vertical font-size-18"></i>
                          </DropdownToggle>

                          <DropdownMenu className="dropdown-menu-end">
                            {usersPermissions.edit && (
                              <DropdownItem
                                onClick={e => {
                                  e.stopPropagation()
                                  handleEditCouponGroup(_id)
                                }}
                              >
                                <i className="mdi mdi-pencil font-size-16 text-success me-1"></i>
                                {t("Edit")}
                              </DropdownItem>
                            )}
                            {usersPermissions.edit && (
                              <DropdownItem
                                onClick={e => {
                                  e.stopPropagation()
                                  setShowDatePicker(true)
                                  setSelectedId(_id)
                                }}
                              >
                                <i className="bx bx-time-five font-size-16 text-primary me-1"></i>
                                {t("Update Expiry Date")}
                              </DropdownItem>
                            )}

                            {usersPermissions.delete && (
                              <DropdownItem
                                onClick={e => {
                                  e.stopPropagation()
                                  setItemIdToDelete(_id)
                                  setShowDeleteModal(true)
                                }}
                              >
                                <i className="mdi mdi-trash-can font-size-16 text-danger me-1"></i>
                                {t("Delete")}
                              </DropdownItem>
                            )}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))
          )}

          {!loading && (
            <div className="mt-3">
              <Card>
                <CardBody>
                  <Paginations
                    data={couponsGroups}
                    itemsPerPage={itemsPerPage}
                    onPageChange={onPageChange}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalCount={totalCount}
                  />
                </CardBody>
              </Card>
            </div>
          )}
        </Row>
      </div>
      <DeleteModal
        show={showDeleteModal}
        isLoading={isLoading}
        onDeleteClick={handleDelete}
        onCloseClick={() => setShowDeleteModal(false)}
        buttonText={"Delete"}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: t("Coupon Group"),
        })}
      />
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {actionType === "EDIT" ? t("Edit") : t("Add")} {t("Coupon Group")}
        </ModalHeader>
        <ModalBody>
          <Formik
            initialValues={formValues}
            enableReinitialize={true}
            validationSchema={addCouponGroupSchema}
            onSubmit={handleAddCouponGroup}
          >
            {({ values, setFieldValue, errors, touched }) => (
              <>
                {actionType === "EDIT" && couponGroupLoading ? (
                  <div className="g_center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <Form>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form_field">
                          <label htmlFor="name">
                            <span className="text-danger">*</span>{" "}
                            {t("Name(English)")}
                          </label>
                          <Field
                            type="text"
                            id="name"
                            name="name"
                            placeholder={t("Name(English)")}
                            className={`form-control ${
                              touched.name && errors.name ? "is-invalid" : ""
                            }`}
                          />
                          <TextError name="name" />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form_field">
                          <label htmlFor="nameAr">
                            <span className="text-danger">*</span>{" "}
                            {t("Name(عربي)")}
                          </label>
                          <Field
                            type="text"
                            id="nameAr"
                            name="nameAr"
                            placeholder={t("Name(عربي)")}
                            className={`form-control ${
                              touched.nameAr && errors.nameAr
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError name="nameAr" />
                        </div>
                      </div>
                      {/* <div className="col-lg-12">
                        <div className="form_field">
                          <label htmlFor="enable">Enable</label>
                          <Switch
                            isChecked={values.status}
                            onClickHandler={() => {
                              setFieldValue("status", !values.status)
                            }}
                          />
                        </div>
                      </div> */}
                    </div>
                    <ModalFooter style={{ borderTop: "unset" }}>
                      <Button color="secondary" onClick={toggle}>
                        {t("Cancel")}
                      </Button>
                      <Button
                        color="success"
                        type="submit"
                        disabled={isLoading || isActionBusy}
                      >
                        {actionType === "EDIT" ? t("Edit") : t("Add")}
                      </Button>
                    </ModalFooter>
                  </Form>
                )}
              </>
            )}
          </Formik>
        </ModalBody>
      </Modal>

      <Modal isOpen={showDatePicker} toggle={() => setShowDatePicker(false)}>
        <ModalHeader toggle={() => setShowDatePicker(false)}>
          {t("Update Bulk Coupon Groups")}
        </ModalHeader>
        <ModalBody>
          <div className="full_rs_picker">
            <label htmlFor="endTime">
              <span className="text-danger">*</span>{" "}
              {t("Select Expires Date & Time")}
            </label>
            <DatePicker
              showTime={{ format: "HH:mm" }}
              format="yyyy-MM-dd HH:mm"
              onChange={value => {
                setExpiresAt(value)
              }}
              value={expiresAt}
              shouldDisableDate={date =>
                isBefore(startOfDay(date), startOfDay(new Date()))
              }
              placement="autoVerticalStart"
              placeholder=" 2024-07-16 14:30"
            />
          </div>
          <div className="d-flex justify-content-end mt-4">
            <Button
              color="secondary"
              className=""
              onClick={() => setShowDatePicker(false)}
            >
              {t("Cancel")}
            </Button>
            <Button
              color="success"
              className="ms-2"
              onClick={handleUpdateBulkCouponGroup}
              disabled={isLoading || !expiresAt || isActionBusy}
            >
              {t("Save")}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default CouponsGroups
